/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageResponses } from "../../funcs/llmUsageResponses.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetResponsesUsageRequest$inboundSchema,
};

export const tool$llmUsageResponses: ToolDefinition<typeof args> = {
  name: "llm-usage-responses",
  description: `Get responses usage

Retrieve usage metrics for agent responses, aggregated from the Response table.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageResponses(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
